import React from 'react';
import { FiZoomIn, FiZoomOut, FiMaximize2 } from 'react-icons/fi';

type ToolbarProps = {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFitView: () => void;
  disabledZoomIn?: boolean;
  disabledZoomOut?: boolean;
  style?: React.CSSProperties;
};

const iconButtonStyle: React.CSSProperties = {
  width: 32,
  height: 32,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 9999,
  backgroundColor: 'var(--color-bg-primary)',
  border: '1px solid var(--color-border-primary)'
};

const Toolbar: React.FC<ToolbarProps> = ({ onZoomIn, onZoomOut, onFitView, disabledZoomIn, disabledZoomOut, style }) => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 16,
        bottom: 16,
        display: 'flex',
        gap: 8,
        ...style
      }}
    >
      <button
        aria-label="Zoom in"
        onClick={onZoomIn}
        disabled={disabledZoomIn}
        className="transition-colors"
        style={{
          ...iconButtonStyle,
          cursor: disabledZoomIn ? 'not-allowed' : 'pointer',
          color: 'var(--color-text-primary)',
          opacity: disabledZoomIn ? 0.6 : 1
        }}
        onMouseEnter={(e) => {
          if (!disabledZoomIn) (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-gray-700)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-bg-primary)';
        }}
      >
        <FiZoomIn size={16} />
      </button>
      <button
        aria-label="Zoom out"
        onClick={onZoomOut}
        disabled={disabledZoomOut}
        className="transition-colors"
        style={{
          ...iconButtonStyle,
          cursor: disabledZoomOut ? 'not-allowed' : 'pointer',
          color: 'var(--color-text-primary)',
          opacity: disabledZoomOut ? 0.6 : 1
        }}
        onMouseEnter={(e) => {
          if (!disabledZoomOut) (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-gray-700)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-bg-primary)';
        }}
      >
        <FiZoomOut size={16} />
      </button>
      <button
        aria-label="Fit view"
        onClick={onFitView}
        className="transition-colors"
        style={{
          ...iconButtonStyle,
          color: 'var(--color-text-primary)'
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-gray-700)';
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.backgroundColor = 'var(--color-bg-primary)';
        }}
      >
        <FiMaximize2 size={16} />
      </button>
    </div>
  );
};

export default Toolbar;
